export enum RightEnum {
  WRITE_REFUND = 'WRITE_REFUND',
}
